import { useQuery } from '@tanstack/react-query';

import { fetchProfiles } from '@/entities/insight/endpoint';
import type { PostFilterMap } from '../../../../entities/post/models';
import type { PublicFilter } from '../../shared/public-filter/use-public-filter';

export function useFilteredProfiles(params: {
  queryId: string;
  startDate: string;
  endDate: string;
  filter: PostFilterMap;
  enabled: boolean;
  publicFilter: PublicFilter;
}) {
  return useQuery({
    queryKey: [
      'filtered-profiles',
      params.queryId,
      params.startDate,
      params.endDate,
      params.filter,
    ],
    queryFn: async ({ signal }) => {
      const response = await fetchProfiles(
        {
          queryId: params.queryId,
          startDate: params.startDate,
          endDate: params.endDate,
          filter: params.filter,
          limit: 100,
          publicFilter: params.publicFilter,
        },
        signal,
      );

      return {
        profiles: response.profiles,
        totalCount: response.count,
      };
    },
    placeholderData: (previousData) => previousData,
    enabled: params.enabled,
  });
}
